import React from "react";
import { Icon, Stack } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { DSATraceabilityInlineModal, useCanRenderDSATraceabilityInlineModal } from "./DSATraceability/index.js";
import useOneWayCombinationInfo from "./FlightDetailsInfo/Items/OneWayCombinationInfo/useOneWayCombinationInfo.js";
import RyanairHungaryInfoMobile, { useCanRenderRyanairHungaryInfoMobile } from "./FlightDetailsInfo/Items/RyanairHungaryInfo/RyanairHungaryInfo.mobile.js";
import useFareRulesStatusInfo from "./FlightDetailsInfo/Items/FareRulesStatusInfo/useFareRulesStatusInfo.js";
import { InconsistentCabinBaggageInfo } from "../../../../ancillaries/components/ExtraProducts/components/InconsistentCabinBaggageInfo.js";
import useExtraProductsInfoController from "./FlightDetailsInfo/Items/ExtraProductsInfo/useExtraProductsInfo.controller.js";
import { hasRenderableReactContent } from "../../../../utils/hasRenderableReactContent.js";
export function FlightDetailsLegalFooterDesktop(props) {
    const { flight, mixin, attributes } = props;
    const fareRulesStatusInfo = useFareRulesStatusInfo(flight);
    const oneWayCombinationInfo = useOneWayCombinationInfo(flight);
    const canRenderDSATraceability = useCanRenderDSATraceabilityInlineModal({ flight });
    const canRenderRyanairHungaryInfo = useCanRenderRyanairHungaryInfoMobile(flight);
    const { inconsistentCabinBaggageInfo } = useExtraProductsInfoController(flight);
    const inconsistentCabinBag = inconsistentCabinBaggageInfo &&
        hasRenderableReactContent(InconsistentCabinBaggageInfo({ renderTextOnly: true, includedProducts: inconsistentCabinBaggageInfo }));
    if (!canRenderRyanairHungaryInfo &&
        !oneWayCombinationInfo?.content &&
        !canRenderDSATraceability &&
        !inconsistentCabinBaggageInfo &&
        !inconsistentCabinBag)
        return null;
    return (React.createElement(Stack, { gap: 2, mixin: mixin, attributes: attributes },
        inconsistentCabinBag ? (React.createElement(Stack, { key: "fare-rules-status", direction: "row", gap: 2 },
            React.createElement(Icon, { svg: InfoSignIcon }),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(InconsistentCabinBaggageInfo, { renderTextOnly: true, includedProducts: inconsistentCabinBaggageInfo })))) : undefined,
        canRenderRyanairHungaryInfo ? (React.createElement(Stack, { key: "ryanair-hungary-info", direction: "row", gap: 2 },
            React.createElement(Icon, { svg: InfoSignIcon }),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(RyanairHungaryInfoMobile, { key: "ryanair-hungary-info", flight: flight })))) : null,
        fareRulesStatusInfo?.content ? (React.createElement(Stack, { key: "fare-rules-status", direction: "row", gap: 2 },
            React.createElement(Icon, { svg: InfoSignIcon }),
            React.createElement(Stack.Item, { grow: true }, fareRulesStatusInfo.content))) : null,
        oneWayCombinationInfo?.content ? (React.createElement(Stack, { key: "one-way-combination", direction: "row", gap: 2 },
            React.createElement(Icon, { svg: InfoSignIcon }),
            React.createElement(Stack.Item, { grow: true }, oneWayCombinationInfo.content))) : null,
        canRenderDSATraceability ? (React.createElement(Stack, { key: "dsa-traceability", direction: "row", gap: 2 },
            React.createElement(Stack.Item, { mixin: { paddingBlockStart: 2 } },
                React.createElement(Icon, { svg: InfoSignIcon })),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(DSATraceabilityInlineModal, { key: "dsa-traceability", flight: flight })))) : null));
}
